import $ from 'jquery'

export default {
  inserted (el) {
    $(el).detach().appendTo('body').drawer({ toggle: false })
  }
}



// WEBPACK FOOTER //
// ./src/directives/drawer.js